import { FormControl, Grid, IconButton, InputLabel, Select, TextField
    , Typography, Stack, Box, Checkbox, FormControlLabel } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListModelo, defaultArea, init as initArea } from "../redux/areaSlice";
import { FormHelperText as HelperText } from '@mui/material';

const Area = (props) => {
    const isReadOnly = props.isReadOnly;
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const inputRef = useRef(null);

    useEffect(() => {
        dispatch(initArea({ sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.autoFocus) {
        const timer = setTimeout(() => inputRef.current?.focus(), 150);
        return () => clearTimeout(timer);
        }
    }, [props.autoFocus]);

    const entity = useSelector((state) => state.area[sliceKey].entity);
    const listModelo = useSelector((state) => state.area[sliceKey].listModelo);
    const validate = useSelector((state) => state.area[sliceKey].validationActive);

    var validation = {
        idModelo: {
            error: entity.idModelo == 0 || entity.idModelo == null,
            message: "Falta ingresar el modelo",
        },
        codigo: {
            error: entity.codigo.length < 1,
            message: "Falta ingresar el codigo del area",
        },
        nombre: {
            error: entity.nombre.length < 1,
            message: "Falta ingresar el nombre del area",
        },
        orden: {
            error: entity.orden < 0,
            message: "Ingrese un número de orden válido",
        },
    }

    const fetchEntity = useCallback(async () => {
        const response = await api.get("/Modelo/GetArea?idArea=" + props.id)
            .catch((err) => {
                console.log("Err: ", err);
            });

        if (props.id == 0){
            dispatch(setEntity({sliceKey: sliceKey, data: defaultArea}));
            dispatch(setData({sliceKey: sliceKey, name: "idModelo", value: props.idModelo}));
        }
        else {
            dispatch(setEntity({sliceKey: sliceKey, data: response.data.data}));
        }
    }, [])
    const fetchModelo = useCallback(async () => {
        const response = await api.get("/Modelo/GetsListModelo")
            .catch((err) => {
                console.log("Err: ", err);
            });

        dispatch(setListModelo({sliceKey: sliceKey, data: response.data.data}));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchModelo();
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }
    // var setDataEntity = e => {
    //     dispatch(setData(e.target));
    // }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    return (
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(entity)} */}
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={8} sm={2}>
                    <FormControl required fullWidth error={validate?.idModelo && validation.idModelo.error}>
                        <InputLabel htmlFor="input-modelo">Modelo</InputLabel>
                        <Select
                            native
                            label="Modelo"
                            value={entity?.idModelo}
                            onChange={(event) => {
                                var id = event.nativeEvent.target.selectedIndex;
                                
                                dispatch(setData({sliceKey: sliceKey, name: "idModelo", value: event.target.value}))
                                dispatch(setData({sliceKey: sliceKey, name: "modelo", value: event.nativeEvent.target[id].text}))
                            }}
                            inputProps={{
                                name: 'idModelo',
                                id: 'input-modelo',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listModelo?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate?.idModelo && validation.idModelo.error ? validation.idModelo.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={4} sm={1}>
                    <TextField
                        required
                        name="codigo"
                        label="Codigo"
                        fullWidth
                        value={entity?.codigo}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        name="nombre"
                        label="Nombre"
                        fullWidth
                        value={entity?.nombre}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        name="descripcion"
                        label="Descripción"
                        fullWidth
                        value={entity?.descripcion}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={3} sm={1}>
                    <TextField
                        name="orden"
                        label="Orden"
                        type='number'
                        fullWidth
                        value={entity?.orden}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
export default Area;
